import React from 'react';
import classes from './classes.module.scss';

function Spiner({
  className = '',
  loaderColor = 'var(--app-color)',
  loaderSize = null,
  loaderBorder = null,
  loaderContainerSize = null
}) {
  const getConteinerClass = () => {
    if (className) return className;
    return classes.loaderConteiner;
  };

  const renderSpiner = () => (
    <div className={ getConteinerClass() }>
      <div className={ classes.loader } style={ { '--loaderContainerSize': loaderContainerSize || '90px' } }>
        <div style={ { '--loaderColor': loaderColor, '--loaderSize': loaderSize || '70px', '--loaderBorder': loaderBorder || '10px' } } />
        <div style={ { '--loaderColor': loaderColor, '--loaderSize': loaderSize || '70px', '--loaderBorder': loaderBorder || '10px' } } />
        <div style={ { '--loaderColor': loaderColor, '--loaderSize': loaderSize || '70px', '--loaderBorder': loaderBorder || '10px' } } />
        <div style={ { '--loaderColor': loaderColor, '--loaderSize': loaderSize || '70px', '--loaderBorder': loaderBorder || '10px' } } />
      </div>
    </div>
  );

  return renderSpiner();
}

export default Spiner;
